{
  "familyId": "SWW-TT-STAM",
  "questions": [
    {
      "id": "SWW-TT-STAM-001",
      "familyId": "SWW-TT-STAM",
      "module": "SpellingWW",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_stam_regel",
      "questionType": "multiple_choice",
      "question": "Ik ... elke dag naar school. (fietsen)",
      "context": null,
      "options": ["fiets", "fietst", "fietste", "gefietst"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "verbTable",
          "data": {
            "verb": "fietsen",
            "tense": "present",
            "persons": ["ik", "jij", "hij/zij"],
            "forms": ["fiets", "fietst", "fietst"],
            "highlight": "ik",
            "label": "Tegenwoordige Tijd"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "present_tense_first_person_stem",
      "variantIndex": 1,
      "feedback": {
        "explanationText": "Stap 1: Bepaal de stam. Werkwoord 'fietsen' min -en = 'fiets'. Stap 2: Bij 'ik' gebruik je alleen de stam (geen -t). Dus: ik fiets.",
        "distractorExplanations": {
          "0": "Correct! 'Fiets' is de stam. Bij 'ik' gebruik je alleen de stam zonder -t.",
          "1": "'Fietst' is fout omdat je bij 'ik' geen -t toevoegt. De -t komt alleen bij hij/zij/het: hij fietst.",
          "2": "'Fietste' is de verleden tijd, niet de tegenwoordige tijd. Het signaalwoord 'elke dag' vraagt om tegenwoordige tijd.",
          "3": "'Gefietst' is het voltooid deelwoord (gebruikt met 'hebben'). Hier is geen hulpwerkwoord, dus gewoon de stam: fiets."
        }
      }
    },
    {
      "id": "SWW-TT-STAM-002",
      "familyId": "SWW-TT-STAM",
      "module": "SpellingWW",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_stam_regel",
      "questionType": "multiple_choice",
      "question": "Zij ... een boek. (lezen)",
      "context": null,
      "options": ["leest", "lees", "las", "gelezen"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "verbTable",
          "data": {
            "verb": "lezen",
            "tense": "present",
            "persons": ["ik", "jij", "hij/zij"],
            "forms": ["lees", "leest", "leest"],
            "highlight": "hij/zij",
            "label": "Tegenwoordige Tijd"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "present_tense_third_person_basic",
      "variantIndex": 2,
      "feedback": {
        "explanationText": "Regel: stamregel tegenwoordige tijd. Stap 1: Bepaal de stam: lezen − en = leez → lees (z wordt s aan het eind van een woord). Stap 2: Bij hij/zij/het voeg je -t toe aan de stam: lees + t = leest. Dus: zij leest.",
        "distractorExplanations": {
          "0": "Correct! Stamregel: bij zij voeg je -t toe aan de stam: lees + t = leest.",
          "1": "Veelgemaakte fout: de ik-vorm gebruiken bij zij. 'Lees' is de stam (ik-vorm). Bij zij moet je -t toevoegen: lees + t = leest. Misconceptie: vergeten dat hij/zij/het altijd -t krijgt.",
          "2": "Veelgemaakte fout: verleden tijd gebruiken in plaats van tegenwoordige tijd. 'Las' is de verleden tijd (sterk werkwoord). Er is geen signaalwoord voor verleden tijd, dus tegenwoordige tijd: leest.",
          "3": "Veelgemaakte fout: voltooid deelwoord gebruiken zonder hulpwerkwoord. 'Gelezen' hoort bij 'heeft gelezen'. Hier is geen hulpwerkwoord 'heeft', dus gewoon tegenwoordige tijd: leest."
        }
      }
    },
    {
      "id": "SWW-TT-STAM-003",
      "familyId": "SWW-TT-STAM",
      "module": "SpellingWW",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_stam_regel",
      "questionType": "multiple_choice",
      "question": "Hij ... de bal ver weg. (trappen)",
      "context": null,
      "options": ["trapt", "trap", "trapte", "getrapt"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "verbTable",
          "data": {
            "verb": "trappen",
            "tense": "present",
            "persons": ["ik", "jij", "hij/zij"],
            "forms": ["trap", "trapt", "trapt"],
            "highlight": "hij/zij",
            "label": "Tegenwoordige Tijd"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "present_tense_third_person_add_t",
      "variantIndex": 3,
      "feedback": {
        "explanationText": "Regel: stamregel tegenwoordige tijd. Stap 1: Bepaal de stam: trappen − en = trapp → trap (dubbele medeklinker wordt enkel). Stap 2: Bij hij/zij/het voeg je altijd -t toe: trap + t = trapt. Dus: hij trapt.",
        "distractorExplanations": {
          "0": "Correct! Stamregel: bij hij voeg je -t toe aan de stam: trap + t = trapt.",
          "1": "Veelgemaakte fout: de ik-vorm gebruiken bij hij. 'Trap' is de stam (ik-vorm). Bij hij moet je -t toevoegen: trap + t = trapt. Misconceptie: vergeten dat hij/zij/het altijd -t krijgt.",
          "2": "Veelgemaakte fout: verleden tijd gebruiken in plaats van tegenwoordige tijd. 'Trapte' is de verleden tijd. Er is geen signaalwoord voor verleden tijd, dus tegenwoordige tijd: trapt.",
          "3": "Veelgemaakte fout: voltooid deelwoord gebruiken zonder hulpwerkwoord. 'Getrapt' hoort bij 'heeft getrapt'. Hier is geen hulpwerkwoord, dus gewoon tegenwoordige tijd: trapt."
        }
      }
    },
    {
      "id": "SWW-TT-STAM-004",
      "familyId": "SWW-TT-STAM",
      "module": "SpellingWW",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_stam_regel",
      "questionType": "multiple_choice",
      "question": "Wat is de stam van het werkwoord 'rennen'?",
      "context": null,
      "options": ["ren", "rent", "renn", "rende"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Stam bepalen",
            "content": "De stam vind je door -en van het hele werkwoord af te halen: rennen → renn → ren. Let op: dubbele medeklinkers worden enkel aan het eind van een woord.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "stem_finding_double_consonant",
      "variantIndex": 4,
      "feedback": {
        "explanationText": "Regel: stam bepalen. Stap 1: Haal -en af: rennen → renn. Stap 2: Een woord eindigt niet op een dubbele medeklinker, dus renn → ren. De stam is 'ren'.",
        "distractorExplanations": {
          "0": "Correct! Rennen − en = renn → ren (dubbele medeklinker wordt enkel aan het eind).",
          "1": "Veelgemaakte fout: de hij-vorm verwarren met de stam. 'Rent' is stam + t (hij rent). De stam zelf is 'ren' (zonder -t). Misconceptie: denken dat de hij-vorm de stam is.",
          "2": "Veelgemaakte fout: de dubbele medeklinker laten staan. 'Renn' is bijna goed, maar een Nederlands woord eindigt niet op een dubbele medeklinker. De stam is 'ren' (enkel).",
          "3": "Veelgemaakte fout: de verleden tijd verwarren met de stam. 'Rende' is de verleden tijd. De stam vind je door -en van het werkwoord af te halen: rennen − en = ren."
        }
      }
    },
    {
      "id": "SWW-TT-STAM-005",
      "familyId": "SWW-TT-STAM",
      "module": "SpellingWW",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_stam_regel",
      "questionType": "multiple_choice",
      "question": "Ik ... graag in het park. (wandelen)",
      "context": null,
      "options": ["wandel", "wandelt", "wandelde", "gewandeld"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "verbTable",
          "data": {
            "verb": "wandelen",
            "tense": "present",
            "persons": ["ik", "jij", "hij/zij"],
            "forms": ["wandel", "wandelt", "wandelt"],
            "highlight": "ik",
            "label": "Tegenwoordige Tijd"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "present_tense_first_person_stem_long",
      "variantIndex": 5,
      "feedback": {
        "explanationText": "Regel: stamregel tegenwoordige tijd. Stap 1: Bepaal de stam: wandelen − en = wandel. Stap 2: Bij 'ik' gebruik je alleen de stam (geen -t). Dus: ik wandel.",
        "distractorExplanations": {
          "0": "Correct! Stamregel: de stam van 'wandelen' is 'wandel'. Bij 'ik' gebruik je alleen de stam.",
          "1": "Veelgemaakte fout: de hij/zij-vorm gebruiken bij ik. 'Wandelt' is stam + t (hij/zij wandelt). Bij 'ik' voeg je geen -t toe. Misconceptie: denken dat ik ook -t krijgt.",
          "2": "Veelgemaakte fout: verleden tijd gebruiken in plaats van tegenwoordige tijd. 'Wandelde' is de verleden tijd. Er is geen signaalwoord voor verleden tijd, dus tegenwoordige tijd: ik wandel.",
          "3": "Veelgemaakte fout: voltooid deelwoord gebruiken zonder hulpwerkwoord. 'Gewandeld' hoort bij 'heb gewandeld'. Hier is geen hulpwerkwoord, dus gewoon de stam: wandel."
        }
      }
    }
  ]
}